import { useCallback, useContext } from "react";
import { useMutation, UseMutationOptions } from "react-query";

import { IUploadTravellerImageParams } from "../domain";
import { apiServiceContext } from "../../api-service-context";

export const useUploadTravellerImage = (
  options?: UseMutationOptions<any, any, IUploadTravellerImageParams>
) => {
  const { uploadApiService } = useContext(apiServiceContext);

  const mutationFn = useCallback(
    (payload: IUploadTravellerImageParams) =>
      uploadApiService.createCancellableRequest((cancelToken) =>
        uploadApiService.uploadTravellerImage(payload, cancelToken)
      ),
    [uploadApiService]
  );

  const mutation = useMutation<any, any, IUploadTravellerImageParams>(mutationFn, options);

  return mutation;
};
